"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { clearFindWorkshopServiceIdMemo } from "@/lib/findWorkshopSession";
import { pathnameToCanonical } from "@/lib/i18nRouting";

function isFindWorkshopPath(pathname: string | null): boolean {
  if (!pathname) return false;
  const c = pathnameToCanonical(pathname);
  return c === "/find-workshop" || c.startsWith("/find-workshop/");
}

/** Drops Strict Mode replay memo when leaving find-workshop so a later visit is not wrongly filtered. */
export function FindWorkshopSessionRouteSync() {
  const pathname = usePathname();
  const wasFindWorkshopRef = useRef(false);

  useEffect(() => {
    const onFindWorkshop = isFindWorkshopPath(pathname);
    if (wasFindWorkshopRef.current && !onFindWorkshop) {
      clearFindWorkshopServiceIdMemo();
    }
    wasFindWorkshopRef.current = onFindWorkshop;
  }, [pathname]);

  return null;
}
